declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}
import { useNavigationType } from 'react-router-dom';
import { useCallback } from 'react';

interface ConsentState {
  ad_storage: 'granted' | 'denied' | undefined;
  ad_user_data: 'granted' | 'denied' | undefined;
  analytics_storage: 'granted' | 'denied' | undefined;
  ad_personalization: 'granted' | 'denied' | undefined;
  functionality_storage: 'granted' | 'denied' | undefined;
  personalization_storage: 'granted' | 'denied' | undefined;
  security_storage: 'granted' | 'denied' | undefined;
}

export const sendConsentEvent = (consentState: ConsentState, method: string) => {
  if (window.gtag) {
    window.gtag('consent', method, consentState);
  }
};

const usePushDataLayerEvent = () => {
  const navigationType = useNavigationType();

  const pushDataLayerEvent = useCallback(
    (eventName: string, eventData?: any, screenName?: string) => {
      let accessType: number | null = null;
      switch (navigationType) {
        case 'PUSH':
          accessType = 1;
          break;
        case 'POP':
          accessType = 2;
          break;
        case 'REPLACE':
          accessType = 3;
          break;
        default:
          accessType = null;
      }

      if (window.dataLayer) {
        window.dataLayer.push({
          event: eventName,
          pantalla: screenName || null,
          tipo_de_acceso: accessType,
          ...eventData,
        });
      }
    },
    [navigationType],
  );

  return { pushDataLayerEvent };
};

export default usePushDataLayerEvent;

interface UserServiceData {
  delayed?: boolean | null;
  selectedVehicle?: { [key: string]: any } | null;
  undergroundParking?: boolean | null;
  externalRoad?: boolean | null;
  [key: string]: any;
}

export const filterUserServiceDataToEvents = (
  data: UserServiceData,
): {
  delayed?: boolean | null;
  insuranceCompany?: string;
  undergroundParking?: boolean | null;
  externalRoad?: boolean | null;
} => {
  const result: {
    delayed?: boolean | null;
    insuranceCompany?: string;
    undergroundParking?: boolean | null;
    externalRoad?: boolean | null;
  } = {};

  if (data.delayed === true || data.delayed === false) {
    result.delayed = data.delayed;
  }

  if (data.selectedVehicle?.insuranceCompany) {
    result.insuranceCompany = data.selectedVehicle.insuranceCompany;
  }

  if (data.undergroundParking === true || data.undergroundParking === false) {
    result.undergroundParking = data.undergroundParking;
  }

  if (data.externalRoad === true || data.externalRoad === false) {
    result.externalRoad = data.externalRoad;
  }

  return result;
};
